// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1W5dx","actions":"Table_actions__1QJ_T","cell":"Table_cell__3JNQb","image":"Table_image__9vwBM","empty":"Table_empty__2jLW_","name":"Table_name__3t4sR"};